import { useTranslation } from 'react-i18next';
import { offerApi } from '@texas/api/endpoints/offerApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { useEffect } from 'react';
import { BaseWidgetProps } from '../widgets';
import { WidgetWrapper } from '../shared/components/WidgetWrapper';
import { WidgetType } from '../shared/types';
import { OffersTable } from './OffersTable';

export function OffersWidget({
  widgetId,
  color,
  customTitle,
}: BaseWidgetProps) {
  const { t } = useTranslation();
  const { data, loading, refetch } = useApiResource(offerApi.getOffersWidget);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <WidgetWrapper
      widgetId={widgetId}
      loading={loading}
      type={WidgetType.TrackOffers}
      customColor={color}
      style="default"
      header={customTitle ?? t('offer.offers')}
    >
      <OffersTable data={data} />
    </WidgetWrapper>
  );
}
